import { Link, NavLink } from "react-router-dom";
import { ShoppingBag, Menu, X, User } from "lucide-react";
import { useEffect, useState } from "react";
import { useStore } from "../lib/store";
import api from "../lib/api";

const links = [
  { to: "/", label: "Home" },
  { to: "/shop", label: "Shop" },
  { to: "/about", label: "About" },
  { to: "/shipping", label: "Shipping" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Contact" },
];

export default function Header() {
  const { count, setCartOpen, user } = useStore();
  const [open, setOpen] = useState(false);
  const [settings, setSettings] = useState(null);
  const [promo, setPromo] = useState(null);

  useEffect(() => {
    api.get("/settings/public").then((r) => setSettings(r.data)).catch(() => {});
    api.get("/promotions/active").then((r) => setPromo(r.data)).catch(() => {});
  }, []);

  const announcement =
    settings?.announcement_active && settings?.announcement
      ? settings.announcement
      : promo?.active && promo?.banner_text
        ? promo.banner_text
        : "";

  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-black/60 border-b border-white/5"
      data-testid="site-header"
    >
      {announcement && (
        <div className="bg-[#C8A97E] text-black text-center text-xs sm:text-sm font-medium px-3 py-2 tracking-wide">
          {announcement}
          {promo?.active && promo?.code && (
            <span className="ml-2 font-bold">Use code: {promo.code}</span>
          )}
        </div>
      )}

      <div className="container-kv flex items-center justify-between py-4">
        <Link to="/" className="flex items-center gap-2" data-testid="logo-link" onClick={() => setOpen(false)}>
          <div className="w-8 h-8 border border-[#C8A97E] flex items-center justify-center">
            <span className="font-serif text-[#C8A97E] text-lg leading-none">K</span>
          </div>
          <span className="font-serif text-xl tracking-wide">Kratoven</span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              className={({ isActive }) =>
                `text-sm tracking-wide transition-colors ${isActive ? "text-[#C8A97E]" : "text-[#A8A5A1] hover:text-white"}`
              }
              data-testid={`nav-${l.label.toLowerCase()}`}
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <Link
            to={user ? "/account" : "/login"}
            className="p-2 text-[#A8A5A1] hover:text-white transition-colors"
            data-testid="account-link"
            aria-label="account"
          >
            <User size={18} />
          </Link>
          <button
            onClick={() => setCartOpen(true)}
            className="relative p-2 text-[#A8A5A1] hover:text-white transition-colors"
            data-testid="cart-open-btn"
            aria-label="open cart"
          >
            <ShoppingBag size={18} />
            {count > 0 && (
              <span
                className="absolute -top-1 -right-1 bg-[#C8A97E] text-black text-[10px] w-4 h-4 flex items-center justify-center rounded-full font-medium"
                data-testid="cart-count"
              >
                {count}
              </span>
            )}
          </button>
          <button
            className="md:hidden p-2 text-[#A8A5A1]"
            onClick={() => setOpen(!open)}
            data-testid="menu-toggle"
            aria-label="menu"
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-white/5 bg-black/90 backdrop-blur-xl" data-testid="mobile-menu">
          <div className="container-kv flex flex-col py-4 gap-1">
            {links.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                className="py-3 text-[#A8A5A1] hover:text-[#C8A97E] transition-colors"
                data-testid={`mnav-${l.label.toLowerCase()}`}
              >
                {l.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
